export enum MusicObjectKey {
  GAME_SELECTED_AUDIO = 'GAME_SELECTED_AUDIO',
  BUTTON = 'BUTTON',
  TAGS = 'TAGS',
  POLYGONS = 'POLYGONS',
  VSIMAGES = 'VSIMAGES',
  PANORAMAS = 'PANORAMAS',
  SWEEPGROUPS = 'SWEEPGROUPS',
  FLOORS = 'FLOORS',
  TOUR = 'TOUR',
}

type PlayMusicObjectType = {
  name: MusicObjectKey;
  priority: number;
};

export type TPlaylist = {
  audio: HTMLAudioElement;
  id: string;
  priority: number;
  type: PlayMusicObjectType;
};

export type TMusicDataEntry = Record<number, HTMLAudioElement>;

export type TMusicData = Record<MusicObjectKey, TMusicDataEntry>;

export type MusicObjectType = {
  [key in MusicObjectKey]: PlayMusicObjectType;
};

export const MusicObj: MusicObjectType = {
  [MusicObjectKey.GAME_SELECTED_AUDIO]: {
    name: MusicObjectKey.GAME_SELECTED_AUDIO,
    priority: 1,
  },
  [MusicObjectKey.BUTTON]: {
    name: MusicObjectKey.BUTTON,
    priority: 2,
  },
  [MusicObjectKey.TAGS]: {
    name: MusicObjectKey.TAGS,
    priority: 2,
  },
  [MusicObjectKey.POLYGONS]: {
    name: MusicObjectKey.POLYGONS,
    priority: 2,
  },
  [MusicObjectKey.VSIMAGES]: {
    name: MusicObjectKey.VSIMAGES,
    priority: 2,
  },
  [MusicObjectKey.PANORAMAS]: {
    name: MusicObjectKey.PANORAMAS,
    priority: 2,
  },
  [MusicObjectKey.SWEEPGROUPS]: {
    name: MusicObjectKey.SWEEPGROUPS,
    priority: 3,
  },
  [MusicObjectKey.FLOORS]: {
    name: MusicObjectKey.FLOORS,
    priority: 4,
  },
  [MusicObjectKey.TOUR]: {
    name: MusicObjectKey.TOUR,
    priority: 5,
  },
};

export type ExportAudio = {
  type: PlayMusicObjectType;
  id: string | number;
  hotspotUrl?: string;
};
